module.exports = __webpack_public_path__ + "img/zuijia_37.7d0d5d13.png";